import React from 'react';

import { clickedFooterLink } from '../../events';

import styles from './styles.sass';

function SocialLink({ platformName }) {
  const { url, component } = getPlatformInfo(platformName);
  return (
    <a
      className={styles.iconLink}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => clickedFooterLink(platformName)}
    >
      {component}
    </a>
  );
}

function getPlatformInfo(platformName) {
  switch (platformName) {
    case 'twitter':
      return {
        url: 'https://twitter.com/anchor',
        component: (
          <svg
            className={styles.svg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19 16"
          >
            <path
              fill="#C9CBCD"
              fillRule="evenodd"
              d="M16.13 2.5A3.9 3.9 0 0 0 17.77.33a7.3 7.3 0 0 1-2.37.95A3.66 3.66 0 0 0 12.67.05a3.83 3.83 0 0 0-3.74 3.92c0 .3.03.6.1.89A10.46 10.46 0 0 1 1.3.76 4.05 4.05 0 0 0 2.47 6a3.6 3.6 0 0 1-1.7-.5v.06c0 1.9 1.3 3.48 3 3.84a3.59 3.59 0 0 1-1.68.07 3.77 3.77 0 0 0 3.5 2.72A7.29 7.29 0 0 1 .04 13.8a10.24 10.24 0 0 0 5.73 1.76c6.88 0 10.64-5.97 10.64-11.15l-.01-.5a7.8 7.8 0 0 0 1.86-2.04c-.67.32-1.39.53-2.14.62z"
            />
          </svg>
        ),
      };
    case 'facebook':
      return {
        url: 'https://www.facebook.com/anchor.fm/',
        component: (
          <svg
            className={styles.svg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
          >
            <path
              fill="#C9CBCD"
              fillRule="evenodd"
              d="M.94.05C.54.05.2.38.2.8v16.2c0 .4.33.74.74.74H9.6V11.1H7.39V8.34h2.2V6.13c0-2.29 1.45-3.4 3.49-3.4.97 0 1.81.06 2.06.1V5.2h-1.42c-1.1 0-1.36.53-1.36 1.3v1.83h2.76l-.55 2.76h-2.21l.04 6.63h4.75c.4 0 .73-.33.73-.74V.8c0-.4-.33-.74-.73-.74H.95z"
            />
          </svg>
        ),
      };
    case 'instagram':
      return {
        url: 'https://www.instagram.com/anchor.fm/',
        component: (
          <svg
            className={styles.svg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <g fill="none" fillRule="evenodd">
              <g>
                <path
                  fill="#C9CBCD"
                  d="M10 0C7.28 0 6.94.03 5.88.08 4.8.1 4.08.28 3.45.53a4.9 4.9 0 0 0-1.77 1.15A4.9 4.9 0 0 0 .52 3.45a7.34 7.34 0 0 0-.46 2.43C.01 6.95 0 7.28 0 10s.01 3.06.06 4.12c.05 1.07.22 1.8.46 2.43.26.66.6 1.22 1.16 1.77.55.56 1.11.9 1.77 1.16.63.24 1.36.41 2.43.46 1.06.05 1.4.06 4.12.06 2.71 0 3.05-.01 4.12-.06a7.34 7.34 0 0 0 2.43-.46 4.9 4.9 0 0 0 1.77-1.16 4.9 4.9 0 0 0 1.15-1.77c.25-.63.42-1.36.46-2.43.05-1.06.06-1.4.06-4.12 0-2.71 0-3.05-.06-4.12a7.34 7.34 0 0 0-.46-2.43 4.9 4.9 0 0 0-1.15-1.77A4.9 4.9 0 0 0 16.55.53a7.34 7.34 0 0 0-2.43-.46C13.05.02 12.72 0 10 0zm0 1.8c2.67 0 2.98.02 4.04.07.97.04 1.5.2 1.85.34.47.18.8.4 1.15.75.35.35.57.68.75 1.15.14.35.3.88.34 1.85.05 1.06.06 1.37.06 4.04s0 2.99-.06 4.04c-.04.98-.2 1.5-.34 1.86-.18.47-.4.8-.75 1.15a3.1 3.1 0 0 1-1.15.75c-.35.13-.88.3-1.85.34-1.06.05-1.37.06-4.04.06s-2.99-.01-4.04-.06c-.98-.04-1.5-.2-1.86-.34a3.1 3.1 0 0 1-1.15-.75 3.1 3.1 0 0 1-.75-1.15c-.13-.35-.3-.88-.34-1.86A69.38 69.38 0 0 1 1.8 10c0-2.67.01-2.98.06-4.04.04-.97.2-1.5.34-1.85.19-.47.4-.8.75-1.15A3.1 3.1 0 0 1 4.1 2.2c.35-.14.88-.3 1.86-.34C7 1.82 7.33 1.8 10 1.8z"
                />
              </g>
              <path
                fill="#C9CBCD"
                d="M10 13.34a3.33 3.33 0 1 1 0-6.67 3.33 3.33 0 0 1 0 6.67zm0-8.47a5.13 5.13 0 1 0 0 10.27 5.13 5.13 0 0 0 0-10.27zM16.53 4.67a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0"
              />
            </g>
          </svg>
        ),
      };
    default:
      return null;
  }
}

export { SocialLink };
